import { render, staticRenderFns } from "./FantasyWordAnswerOption.vue?vue&type=template&id=7eb1c859&scoped=true"
import script from "./FantasyWordAnswerOption.vue?vue&type=script&lang=ts"
export * from "./FantasyWordAnswerOption.vue?vue&type=script&lang=ts"
import style0 from "./FantasyWordAnswerOption.vue?vue&type=style&index=0&id=7eb1c859&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eb1c859",
  null
  
)

export default component.exports